import React, { useState, useEffect } from 'react';
import LeadSpaceBlock from './carbon-ibm/LeadSpaceBlock';

export interface IPropsMSLeadSpaceBlockData {
  heading?: string;
  copy?: string;
  primaryCtaUrl: string;
  primaryCtaText: string;
  secondaryCtaUrl: string;
  secondaryCtaText: string;
  defaultImage?: string;
  imageSm?: string;
  imageMd?: string;
  imageLg?: string;
  imageXlg?: string;
  imageMax?: string;
  type?: string;
  theme?: string;
}

const MSLeadSpaceBlock = ({
  heading,
  copy,
  primaryCtaUrl,
  primaryCtaText,
  secondaryCtaUrl,
  secondaryCtaText,
  defaultImage,
  imageSm,
  imageMd,
  imageLg,
  imageXlg,
  imageMax,
  theme = 'dark',
  type = 'tall'
}: IPropsMSLeadSpaceBlockData) => {
  return (
    <>
      <LeadSpaceBlock
        heading={heading}
        copy={copy}
        primaryCtaUrl={primaryCtaUrl}
        primaryCtaText={primaryCtaText}
        secondaryCtaUrl={secondaryCtaUrl}
        secondaryCtaText={secondaryCtaText}
        theme={theme}
        type={type}
        defaultImage={defaultImage}
        imageSm={imageSm}
        imageMd={imageMd}
        imageLg={imageLg}
        imageXlg={imageXlg}
        imageMax={imageMax}
      />
    </>
  );
};
export default MSLeadSpaceBlock;
